import React, { useEffect, useState } from 'react';
import { walletAPI } from '../../services/api';
import SlipViewer from '../../components/SlipViewer';

export default function MyRequests() {
  const [items, setItems] = useState([]);
  const [status, setStatus] = useState('');
  const [page, setPage] = useState(1);
  const [loading, setLoading] = useState(false);

  const load = async () => {
    setLoading(true);
    try {
      const res = await walletAPI.getPaymentRequests({ status, page });
      // Handle paginated response - data is in res.data.data
      setItems(res.data?.data || res.data || []);
    } catch (error) {
      console.error('Error loading payment requests:', error);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    load();
  }, [status, page]);

  const getStatusBadge = (status) => {
    const colors = {
      pending: 'bg-yellow-100 text-yellow-800',
      approved: 'bg-green-100 text-green-800',
      rejected: 'bg-red-100 text-red-800'
    };
    return colors[status] || 'bg-gray-100 text-gray-800';
  };



  return (
    <div className="p-4">
      <h2 className="text-xl font-semibold mb-3">My Payment Requests</h2>
      
      <div className="mb-4">
        <select 
          value={status} 
          onChange={e => setStatus(e.target.value)} 
          className="border p-2 rounded"
        >
          <option value="">All Status</option>
          <option value="pending">Pending</option>
          <option value="approved">Approved</option>
          <option value="rejected">Rejected</option>
        </select>
      </div>

      {loading ? (
        <div className="text-center py-4">Loading...</div>
      ) : (
        <div className="space-y-3">
          {items.length === 0 ? (
            <div className="text-center py-8 text-gray-500">
              No payment requests found
            </div>
          ) : (
            items.map(r => (
              <div key={r.id} className="border p-4 rounded-lg shadow-sm">
                <div className="flex justify-between items-start">
                  <div className="flex-1">
                    <div className="font-medium text-lg">
                      ₹{parseFloat(r.amount).toLocaleString()}
                    </div>
                    <div className="text-sm text-gray-600">
                      {new Date(r.transfer_at).toLocaleString()}
                    </div>
                    <div className="text-sm text-gray-600">
                      UTR: {r.utr_number}
                    </div>
                    {r.description && (
                      <div className="text-sm mt-1 text-gray-700">
                        {r.description}
                      </div>
                    )}
                    {r.review_note && (
                      <div className="text-sm mt-2 p-2 bg-gray-50 rounded">
                        <strong>Admin Note:</strong> {r.review_note}
                      </div>
                    )}
                  </div>
                  <div className="text-right">
                    <span className={`text-xs px-2 py-1 rounded-full capitalize ${getStatusBadge(r.status)}`}>
                      {r.status}
                    </span>
                    {r.reviewed_at && (
                      <div className="text-xs text-gray-500 mt-1">
                        Reviewed: {new Date(r.reviewed_at).toLocaleDateString()}
                      </div>
                    )}
                    
                    {/* Slip viewing buttons */}
                    <div className="mt-2">
                      <SlipViewer 
                        requestId={r.id} 
                        slipPath={r.slip_path}
                        className="flex flex-col space-y-1"
                      />
                    </div>
                  </div>
                </div>
              </div>
            ))
          )}
        </div>
      )}
    </div>
  );
}
